import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  //
};

const mutations = {
  SET_META(state, payload) {
    if (payload) {
      state.meta.page = payload.current_page;
      state.meta.itemsPerPage = payload.per_page;
      state.meta.lastPage = payload.last_page;
      state.meta.totalItems = payload.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  ADD_LIST(state, payload) {
    state.list.push(payload);
  },
  UPDATE_LIST(state, row) {
    const item = state.list.find((item) => item.id === row.id);
    Object.assign(item, row);
  },
  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return Service.get("routes/geofence-route-and-stops", params)
      .then((data) => {
        store.commit("SET_META", data?.body?.meta);
        store.commit("SET_LIST", data?.body?.data);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  add: (store, { payload }) => {
    store.state.loading = true;
    return Service.post("routes/geofence-route-and-stops", payload)
      .then((data) => {
        store.commit("ADD_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  update: (store, params) => {
    store.state.loading = true;
    return Service.update(`routes/geofence-route-and-stops`, params)
      .then((data) => {
        store.commit("UPDATE_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
};

const routes = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default routes;
